module.exports = __webpack_public_path__ + "img/img_sub_prod_brityrpa01.ae06234d.svg";